// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TableNumber{font-size:140%}.PopupMenu .mb__popup-box .mb__popup-item .mb__popup-contents.CheckOut{padding:1rem}.CartListArea .StaffName{margin:.5rem 1rem}.CartListArea .mb__flex-box{padding:.5rem 1rem}[v-cloak]{display:none}", ""]);
// Exports
module.exports = exports;
